export const CTA = () => {
  const url = "https://maps.app.goo.gl/7dMkhzgd52KHvuNz7";
  return (
    <div className="wrapper-cta w-[100%] h-[300px] md:h-[400px]  bg-golden flex items-center justify-center">
      <div className="cta-inner-action md:max-w-[1210px] w-[calc(100%_-_60px)] ">
        <h3 className="text-[20px] md:text-[35px] text-white text-center leading-2 font-[400] ">
          Book online today and experience your home away from your home
        </h3>
        <p className="text-center text-white my-[20px] text-[15px] md:text-[18px] hidden md:block">
          <span className="font-bold">Email</span> us at
          thecountryyard.70@gmail.com or{" "}
          <span className="font-bold">Call us</span> on +9779819730006
        </p>
        <div className="flex justify-center items-center">
          <button
            id="location-btn"
            className="bg-golden w-[200px] h-[50px] text-white font-bold border-2 border-white mt-[30px] md:mt-[10px] "
            onClick={() => {
              window.open(url);
            }}
          >
            <p className="">Location</p>
          </button>
        </div>
      </div>
    </div>
  );
};
